export const quotes = [
    {
        q: "Be courteous to all, but intimate with few, and let those few be well tried before you give them your confidence.",
        a: "George Washington",
        c: "114",
        h: "<blockquote>“Be courteous to all, but intimate with few, and let those few be well tried before you give them your confidence.” — <footer>George Washington</footer></blockquote>"
    },
    {
        q: "The goal of an artist is to create the definitive work that cannot be surpassed.",
        a: "George Bernard Shaw",
        c: "80",
        h: "<blockquote>“The goal of an artist is to create the definitive work that cannot be surpassed.” — <footer>George Bernard Shaw</footer></blockquote>"
    },
    {
        q: "Truth is like the sun. You can shut it out for a time, but it ain't going away.",
        a: "Elvis Presley",
        c: "79",
        h: "<blockquote>“Truth is like the sun. You can shut it out for a time, but it ain't going away.” — <footer>Elvis Presley</footer></blockquote>"
    },
    {
        q: "Success is not final, failure is not fatal: It is the courage to continue that counts.",
        a: "Winston Churchill",
        c: "94",
        h: "<blockquote>“Success is not final, failure is not fatal: It is the courage to continue that counts.” — <footer>Winston Churchill</footer></blockquote>"
    },
    {
        q: "The only way to do great work is to love what you do.",
        a: "Steve Jobs",
        c: "58",
        h: "<blockquote>“The only way to do great work is to love what you do.” — <footer>Steve Jobs</footer></blockquote>"
    },
    {
        q: "Don't watch the clock; do what it does. Keep going.",
        a: "Sam Levenson",
        c: "54",
        h: "<blockquote>“Don't watch the clock; do what it does. Keep going.” — <footer>Sam Levenson</footer></blockquote>"
    },
    {
        q: "The secret of getting ahead is getting started.",
        a: "Mark Twain",
        c: "49",
        h: "<blockquote>“The secret of getting ahead is getting started.” — <footer>Mark Twain</footer></blockquote>"
    },
    {
        q: "It always seems impossible until it's done.",
        a: "Nelson Mandela",
        c: "47",
        h: "<blockquote>“It always seems impossible until it's done.” — <footer>Nelson Mandela</footer></blockquote>"
    },
    {
        q: "Believe you can and you're halfway there.",
        a: "Theodore Roosevelt",
        c: "48",
        h: "<blockquote>“Believe you can and you're halfway there.” — <footer>Theodore Roosevelt</footer></blockquote>"
    },
    {
        q: "Act as if what you do makes a difference. It does.",
        a: "William James",
        c: "49",
        h: "<blockquote>“Act as if what you do makes a difference. It does.” — <footer>William James</footer></blockquote>"
    },
    {
        q: "Do not wait; the time will never be 'just right.'",
        a: "Napoleon Hill",
        c: "53",
        h: "<blockquote>“Do not wait; the time will never be 'just right.'” — <footer>Napoleon Hill</footer></blockquote>"
    },
    {
        q: "Quality means doing it right when no one is looking.",
        a: "Henry Ford",
        c: "53",
        h: "<blockquote>“Quality means doing it right when no one is looking.” — <footer>Henry Ford</footer></blockquote>"
    },
    {
        q: "Perfection is not attainable, but if we chase perfection we can catch excellence.",
        a: "Vince Lombardi",
        c: "87",
        h: "<blockquote>“Perfection is not attainable, but if we chase perfection we can catch excellence.” — <footer>Vince Lombardi</footer></blockquote>"
    },
    {
        q: "Work hard in silence, let your success be the noise.",
        a: "Frank Ocean",
        c: "61",
        h: "<blockquote>“Work hard in silence, let your success be the noise.” — <footer>Frank Ocean</footer></blockquote>"
    },
    {
        q: "Opportunities don't happen, you create them.",
        a: "Chris Grosser",
        c: "48",
        h: "<blockquote>“Opportunities don't happen, you create them.” — <footer>Chris Grosser</footer></blockquote>"
    },
    {
        q: "Dream big and dare to fail.",
        a: "Norman Vaughan",
        c: "33",
        h: "<blockquote>“Dream big and dare to fail.” — <footer>Norman Vaughan</footer></blockquote>"
    },
    {
        q: "Do what you can, with what you have, where you are.",
        a: "Theodore Roosevelt",
        c: "52",
        h: "<blockquote>“Do what you can, with what you have, where you are.” — <footer>Theodore Roosevelt</footer></blockquote>"
    },
    {
        q: "Don't be pushed around by the fears in your mind. Be led by the dreams in your heart.",
        a: "Roy T. Bennett",
        c: "97",
        h: "<blockquote>“Don't be pushed around by the fears in your mind. Be led by the dreams in your heart.” — <footer>Roy T. Bennett</footer></blockquote>"
    },
    {
        q: "Believe in yourself and all that you are. Know that there is something inside you that is greater than any obstacle.",
        a: "Christian D. Larson",
        c: "124",
        h: "<blockquote>“Believe in yourself and all that you are. Know that there is something inside you that is greater than any obstacle.” — <footer>Christian D. Larson</footer></blockquote>"
    },
    {
        q: "Success is not how high you have climbed, but how you make a positive difference to the world.",
        a: "Roy T. Bennett",
        c: "101",
        h: "<blockquote>“Success is not how high you have climbed, but how you make a positive difference to the world.” — <footer>Roy T. Bennett</footer></blockquote>"
    },
    {
        q: "It does not matter how slowly you go as long as you do not stop.",
        a: "Confucius",
        c: "67",
        h: "<blockquote>“It does not matter how slowly you go as long as you do not stop.” — <footer>Confucius</footer></blockquote>"
    },
    {
        q: "Difficult roads often lead to beautiful destinations.",
        a: "Zig Ziglar",
        c: "56",
        h: "<blockquote>“Difficult roads often lead to beautiful destinations.” — <footer>Zig Ziglar</footer></blockquote>"
    },
    {
        q: "Do not be embarrassed by your failures, learn from them and start again.",
        a: "Richard Branson",
        c: "78",
        h: "<blockquote>“Do not be embarrassed by your failures, learn from them and start again.” — <footer>Richard Branson</footer></blockquote>"
    },
    {
        q: "Push yourself, because no one else is going to do it for you.",
        a: "Anonymous",
        c: "61",
        h: "<blockquote>“Push yourself, because no one else is going to do it for you.” — <footer>Anonymous</footer></blockquote>"
    },
    {
        q: "Great things never come from comfort zones.",
        a: "Anonymous",
        c: "48",
        h: "<blockquote>“Great things never come from comfort zones.” — <footer>Anonymous</footer></blockquote>"
    },
    {
        q: "Success doesn’t come to you, you go to it.",
        a: "Marva Collins",
        c: "51",
        h: "<blockquote>“Success doesn’t come to you, you go to it.” — <footer>Marva Collins</footer></blockquote>"
    },
    {
        q: "If you can dream it, you can achieve it.",
        a: "Zig Ziglar",
        c: "42",
        h: "<blockquote>“If you can dream it, you can achieve it.” — <footer>Zig Ziglar</footer></blockquote>"
    },
    {
        q: "Do not give up, the beginning is always the hardest.",
        a: "Anonymous",
        c: "58",
        h: "<blockquote>“Do not give up, the beginning is always the hardest.” — <footer>Anonymous</footer></blockquote>"
    },
    {
        q: "If you're going through hell, keep going.",
        a: "Winston Churchill",
        c: "45",
        h: "<blockquote>“If you're going through hell, keep going.” — <footer>Winston Churchill</footer></blockquote>"
    },
    {
        q: "The harder you work for something, the greater you'll feel when you achieve it.",
        a: "Anonymous",
        c: "86",
        h: "<blockquote>“The harder you work for something, the greater you'll feel when you achieve it.” — <footer>Anonymous</footer></blockquote>"
    },
    {
        q: "Success is the sum of small efforts, repeated day in and day out.",
        a: "Robert Collier",
        c: "76",
        h: "<blockquote>“Success is the sum of small efforts, repeated day in and day out.” — <footer>Robert Collier</footer></blockquote>"
    },
    {
        q: "Don’t wait for opportunity. Create it.",
        a: "Anonymous",
        c: "39",
        h: "<blockquote>“Don’t wait for opportunity. Create it.” — <footer>Anonymous</footer></blockquote>"
    },
    {
        q: "Success doesn’t just find you. You have to go out and get it.",
        a: "Anonymous",
        c: "63",
        h: "<blockquote>“Success doesn’t just find you. You have to go out and get it.” — <footer>Anonymous</footer></blockquote>"
    },
    {
        q: "A little progress each day adds up to big results.",
        a: "Satya Nani",
        c: "52",
        h: "<blockquote>“A little progress each day adds up to big results.” — <footer>Satya Nani</footer></blockquote>"
    },
    {
        q: "You don’t have to be great to start, but you have to start to be great.",
        a: "Zig Ziglar",
        c: "71",
        h: "<blockquote>“You don’t have to be great to start, but you have to start to be great.” — <footer>Zig Ziglar</footer></blockquote>"
    },
    {
        q: "Failure is the opportunity to begin again more intelligently.",
        a: "Henry Ford",
        c: "61",
        h: "<blockquote>“Failure is the opportunity to begin again more intelligently.” — <footer>Henry Ford</footer></blockquote>"
    },
    {
        q: "Do something today that your future self will thank you for.",
        a: "Anonymous",
        c: "64",
        h: "<blockquote>“Do something today that your future self will thank you for.” — <footer>Anonymous</footer></blockquote>"
    },
    {
        q: "Work hard, stay positive, and make it happen.",
        a: "Anonymous",
        c: "49",
        h: "<blockquote>“Work hard, stay positive, and make it happen.” — <footer>Anonymous</footer></blockquote>"
    },
    {
        q: "Don’t stop until you’re proud.",
        a: "Anonymous",
        c: "33",
        h: "<blockquote>“Don’t stop until you’re proud.” — <footer>Anonymous</footer></blockquote>"
    },
    {
        q: "Hustle until your haters ask if you're hiring.",
        a: "Anonymous",
        c: "55",
        h: "<blockquote>“Hustle until your haters ask if you're hiring.” — <footer>Anonymous</footer></blockquote>"
    },
    {
        q: "Doubt kills more dreams than failure ever will.",
        a: "Suzy Kassem",
        c: "54",
        h: "<blockquote>“Doubt kills more dreams than failure ever will.” — <footer>Suzy Kassem</footer></blockquote>"
    },
    {
        q: "Your only limit is your mind.",
        a: "Anonymous",
        c: "31",
        h: "<blockquote>“Your only limit is your mind.” — <footer>Anonymous</footer></blockquote>"
    },
    {
        q: "Make your dreams happen, not excuses.",
        a: "Anonymous",
        c: "42",
        h: "<blockquote>“Make your dreams happen, not excuses.” — <footer>Anonymous</footer></blockquote>"
    }
];